export type ChangeChecklistApiResponse = unknown;
export type ChangeChecklistApiArg = {
  resourceId: string;
  recordId: string;
  body: ChangeChecklistRequestBody;
};
export type CreateChecklistApiResponse = /** status 201  */ {
  id: string;
};
export type CreateChecklistApiArg = {
  resourceId: string;
  recordId: string;
  body: CreateChecklistRequestBody;
};
export type GetChecklistApiResponse = /** status 200  */ ChecklistResponseBody;
export type GetChecklistApiArg = {
  resourceId: string;
  recordId: string;
};
export type DeleteChecklistApiResponse = unknown;
export type DeleteChecklistApiArg = {
  checklistId: string;
};
export type CreateChecklistDefinitionApiResponse = /** status 201  */ {
  id: string;
};
export type CreateChecklistDefinitionApiArg = {
  /** User JWT tokens are allowed */
  authorization?: string;
  body: CreateChecklistDefinitionRequestBody;
};
export type ListChecklistDefinitionApiResponse =
  /** status 200  */ ChecklistDefinitionResponseBody[];
export type ListChecklistDefinitionApiArg = {
  resourceId?: string;
};
export type DeleteChecklistDefinitionApiResponse = unknown;
export type DeleteChecklistDefinitionApiArg = {
  definitionId: string;
};
export type GetChecklistDefinitionApiResponse = /** status 200  */ ChecklistDefinitionResponseBody;
export type GetChecklistDefinitionApiArg = {
  definitionId: string;
};
export type UpdateChecklistDefinitionApiResponse = unknown;
export type UpdateChecklistDefinitionApiArg = {
  definitionId: string;
  body: UpdateChecklistDefinitionRequestBody;
};
export type SetDefaultChecklistDefinitionApiResponse = unknown;
export type SetDefaultChecklistDefinitionApiArg = {
  definitionId: string;
};
export type RemoveDefaultChecklistDefinitionApiResponse = unknown;
export type RemoveDefaultChecklistDefinitionApiArg = {
  definitionId: string;
};
export type AddTaskFileApiResponse = unknown;
export type AddTaskFileApiArg = {
  resourceId: string;
  recordId: string;
  checklistId: string;
  taskId: string;
  body: AddTaskFileRequestBody;
};
export type RemoveTaskFileApiResponse = unknown;
export type RemoveTaskFileApiArg = {
  resourceId: string;
  recordId: string;
  checklistId: string;
  taskId: string;
  fileId: string;
};
export type MarkTaskDoneApiResponse = unknown;
export type MarkTaskDoneApiArg = {
  resourceId: string;
  recordId: string;
  checklistId: string;
  taskId: string;
};
export type MarkTaskUndoneApiResponse = unknown;
export type MarkTaskUndoneApiArg = {
  resourceId: string;
  recordId: string;
  checklistId: string;
  taskId: string;
};
export type UpdateTaskNoteApiResponse = unknown;
export type UpdateTaskNoteApiArg = {
  resourceId: string;
  recordId: string;
  checklistId: string;
  taskId: string;
  body: UpdateTaskNoteRequestBody;
};
export type ChangeChecklistRequestBody = {
  definitionId: string;
};
export type CreateChecklistRequestBody = {
  definitionId: string;
};
export type ProgressResponseBody = {
  doneCount: number;
  totalCount: number;
  progress: number;
};
export type ChecklistResponseBody = {
  id: string;
  checklistDefinitionId: string;
  name: string;
  description: string | null;
  progress: ProgressResponseBody;
  createdAt: string;
  tasks: {
    id: string;
    markedAsDone: boolean;
    user: {
      id: string;
      firstName: string;
      lastName: string;
    } | null;
    note: string;
    isMandatory: boolean;
    fileRequired: boolean;
    description: string;
    updatedAt: string;
    finishedAt: string | null;
    files: {
      id: string;
      remoteId: string;
      originalFilename: string;
      contentType: string | null;
      size: number | null;
      fileUri: string;
    }[];
  }[];
};
export type CreateTaskDefinitionRequestBody = {
  isMandatory: boolean;
  fileRequired: boolean;
  description: string;
};
export type CreateChecklistDefinitionRequestBody = {
  name: string;
  description?: string | null;
  resourceId: string;
  tasks: CreateTaskDefinitionRequestBody[];
};
export type TaskDefinitionResponseBody = {
  id: string;
  isMandatory: boolean;
  fileRequired: boolean;
  description: string;
};
export type ChecklistDefinitionResponseBody = {
  id: string;
  name: string;
  description: string | null;
  resourceId: string;
  default: boolean;
  tasks: TaskDefinitionResponseBody[];
};
export type UpdateTaskDefinitionRequestBody = {
  isMandatory: boolean;
  fileRequired: boolean;
  description: string;
  id?: string | null;
};
export type UpdateChecklistDefinitionRequestBody = {
  resourceId: string;
  name: string;
  description?: string | null;
  tasks: UpdateTaskDefinitionRequestBody[];
};
export type AddTaskFileRequestBody = {
  fileId: string;
};
export type UpdateTaskNoteRequestBody = {
  note: string;
};
